import {supabase} from '../../supabase.client';
const useRecentApi = () => {
  const fetchRecents = async (userId) => {
    try {
      try {
        const {data, error} = await supabase.rpc('get_recent_items', {
          arg_user_id: userId
        });
        if(error) {
          throw error;
        } else {
          return data;
        }
      } catch (error) {
        console.error(error);
      }
    } catch (e) {
      console.error(e);
    }
  };
  return {
    fetchRecents
  }
};
export default useRecentApi;
